import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';
import PostType from '@research-api/utils/api/typings/PostType';

import ResearchTeaser from '@/components/pages/frontpage/components/Feature/Right/ResearchTeaser';
import RecentResearchHeader from '@/components/sections/Right/RecentResearchHeader';

type RecentResearchProps = {
    recentResearch: PostType | null;
    hideHeader?: boolean;
    headerTitle?: string;
    className?: string;
};

const RecentResearch = (props: RecentResearchProps) => {
    const { recentResearch, hideHeader, headerTitle, className } = props;

    return (
        <div className={classNames('items-start')}>
            {!hideHeader && <RecentResearchHeader title={headerTitle || 'recent research'} />}
            {recentResearch && (
                <div className={classNames('pt-10 px-10', className)}>
                    <ResearchTeaser
                        headerTitle="Research"
                        slug={recentResearch.slug || ''}
                        title={recentResearch.title || ''}
                        image={recentResearch.featureImage ?? null}
                        description={recentResearch.excerpt}
                        authorTitle={recentResearch.primaryAuthor?.name || 'Research Team'}
                        authorUrl={`https://www.blockworksresearch.com/team/${
                            recentResearch.primaryAuthor?.slug || ''
                        }`}
                        publishedAt={recentResearch.publishedAtTimestamp || 0}
                        className=""
                    />
                </div>
            )}
        </div>
    );
};

export default RecentResearch;
